<template>
  <div class="listContent">
    <div v-if="!isShare">
      <!--      <swiper :items="attUrls.pics" :initIndex="initIndex" v-if="isBigImgShow" v-on:close="closeImg"></swiper>-->
      <router-link :to="{name: 'topicColumnDetail', params: { discussID ,topicItem }}">
        <div :class="contC" v-html="parseSpace(content)"></div>
      </router-link>
      <div :class="imgContainer" v-if="isImgShow && attUrls.pics ">
        <img @click="bigImage(imgindex)" v-for="(img,imgindex) in attUrls.pics" :key="img"
             :src="`${img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')}`"
             :class="imgC">
      </div>
      <router-link :to="{ name: 'topicColumnDetail', params: { discussID , topicItem}}">
        <div v-if="isTipShow" class="listContent_tip themeColor">更多精彩内容，看详情</div>
      </router-link>
    </div>
    <div v-else>
      <!--      <swiper :items="attUrls.pics" :initIndex="initIndex" v-if="isBigImgShow" v-on:close="closeImg"></swiper>-->
      <div>
        <div :class="contC" v-html="parseSpace(content)"></div>
      </div>
      <div :class="imgContainer" v-if="isImgShow &&  attUrls.pics ">
        <img v-for="(img,imgindex) in attUrls.pics" :key="img"
             :src="`${img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')}`"
             :class="imgC">
      </div>
      <div @click="openHrefApp">
        <div v-if="isTipShow" class="listContent_tip themeColor">更多精彩内容 请下载客户端查看</div>
      </div>
    </div>
  </div>
</template>
<script>
  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1 || /(Mobile)/gi.test(_userAgent)
  import utils from '../../tool/utils'
  export default {
    data () {
      return {
        isImgShow: true,
        isTipShow: false,
        initIndex: 1,
        isBigImgShow: false,
        imgContainer: 'imgContainer1',
        contC: {
          content1: false,
          content2: true
        },
        imgC: {
          img1: true,
          img2: false,
          img3: false
        },
        isShare: false
      }
    },
    beforeMount () {
      // if (_agent && _isMobile) {
      //   this.isShare = true
      // } else {
      //   this.isShare = false
      // }
      this.isShare = false
      // console.log(this.item, 'listcontent')
    },
    mounted () {
      if (this.isEmptyObject(this.attUrls)) {
        this.contC.content1 = true
        this.contC.content2 = false
        this.isImgShow = false
        if (this.content.length > 88) {
          this.isTipShow = true
        }
      } else {
        if (this.attUrls.pics.length >= 3) {
          this.imgC.img1 = false
          this.imgC.img2 = false
          this.imgC.img3 = true
          this.imgContainer = 'imgContainer3'
          this.isTipShow = true
        } else if (this.attUrls.pics.length > 1) {
          this.imgC.img1 = false
          this.imgC.img2 = true
          this.imgC.img3 = false
          this.imgContainer = 'imgContainer2'
        }
      }
    },
    methods: {
      isEmptyObject (obj) {
        for (let key in obj) {
          return false
        }
        return true
      },
      bigImage (index) {
        this.isBigImgShow = true
        this.initIndex = index
      },
      closeImg () {
        this.isBigImgShow = false
      },
      openHrefApp () {
        window.location = sessionStorage.getItem('downAppHref')
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      }
    },
    components: {
      // swiper
    },
    props: ['content', 'attUrls', 'discussID', 'topicItem'],
    beforeUpdate () {
//    console.log('beforeUpdate')
    },
    updated: function () {
//    console.log('updated')
    }
  }
</script>

<style scoped>
  .listContent {
    margin: 0.3rem 0.1rem 0.28rem 0.76rem;
    font-size: 0.32rem;
  }

  .listContent_tip {
    font-size: 0.23rem;
    margin: 0.2rem 0 0.06rem 0;
    text-align: right;
  }

  .content1 {
    color: #333333;
    width: 6.24rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .content2 {
    color: #333333;
    width: 6.24rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .imgContainer1,
  .imgContainer2,
  .imgContainer3 {
    width: 6.24rem;
    margin-top: 0.28rem;
    overflow: hidden;
  }

  .imgContainer1 {
    height: 3.12rem;
  }

  .imgContainer2 {
    height: 3.06rem;
  }

  .imgContainer3 {
    height: 2.87rem;
  }

  .img1 {
    width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .img2 {
    width: 3.06rem;
    height: 3.06rem;
    object-fit: cover;
    object-position: center;
  }

  .imgContainer2 img:first-child {
    margin-right: 0.12rem;
  }

  .imgContainer3 img:first-child {
    width: 4.1rem;
    height: 2.87rem;
    object-fit: cover;
    object-position: center;
    float: left;
    top: 0;
  }

  .imgContainer3 img:nth-child(2) {
    width: 2.04rem;
    height: 1.37rem;
    margin-bottom: 0.12rem;
    object-fit: cover;
    object-position: center;
    float: right;
    top: 0;
  }

  .imgContainer3 img:nth-child(3) {
    width: 2.04rem;
    height: 1.37rem;
    object-fit: cover;
    object-position: center;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// listcontent.vue?5d44311f